"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _SnoozeMenu = require("../../../containers/SnoozeMenu");

var _AssociateMenuItem = require("../../ActionModals/AssociateAction/components/AssociateMenuItem");

const Wrapper = _styledComponents.default.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: ${_blocks.spacing.ultraLoose};
  background: ${_blocks.palette.neutral2};
  cursor: default;
  height: 40px;
  z-index: ${_blocks.layer.first};
`;
const Snooze = (0, _styledComponents.default)(_blocks.Button)`
  margin-left: ${_blocks.spacing.default};
`;

const EquipActions = ({
  createTicket,
  equipRuleIds
}) => /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_blocks.ControlGroup, {
  tight: true
}, /*#__PURE__*/_react.default.createElement(_blocks.Button, {
  wafer: true,
  additive: true,
  appearance: "solid",
  onClick: createTicket
}, "Add Action"), /*#__PURE__*/_react.default.createElement(_AssociateMenuItem.AssociateMenuItem, {
  equipRuleIds: equipRuleIds
}, /*#__PURE__*/_react.default.createElement(_blocks.Button, {
  wafer: true,
  primary: true,
  appearance: "solid"
}, "Associate with Action"))), /*#__PURE__*/_react.default.createElement(_blocks.Menu, null, ({
  isOpen,
  toggle,
  close
}) => /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(Snooze, {
  wafer: true,
  appearance: "solid",
  onClick: toggle
}, "Snooze ", /*#__PURE__*/_react.default.createElement(_blocks.ArrowDropdownDown, {
  tiny: true,
  fillColor: _blocks.palette.pureWhite
})), isOpen && /*#__PURE__*/_react.default.createElement(_blocks.Popover, {
  right: true
}, /*#__PURE__*/_react.default.createElement(_SnoozeMenu.SnoozeMenu, {
  showUnsnooze: true,
  equipRuleIds: equipRuleIds,
  onClick: close
})))));

EquipActions.propTypes = {};
var _default = EquipActions;
exports.default = _default;
module.exports = exports.default;